import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form/immutable';
import { Button, Form } from 'semantic-ui-react';
import RenderField from './RenderField';
import TextAreaField from './TextAreaField';
import { withTranslation } from "react-i18next";


export function validate(values) {
  // IMPORTANT: values is an Immutable.Map here!
  const email = values.get('email');
  const message = values.get('message');
  const errors = {};
  if (!email) {
    errors.email = 'Required';
  } else if (
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)
  ) {
    errors.email = 'Invalid email address';
  } if (!message) {
    errors.message = 'Required';
  }
  return errors;
}
const ContactForm = (props) => {
  const {
    onSubmitInfo,
    handleSubmit,
  } = props;

  // Translations
  const { t } = props;
  const keys = {
    title: 'contactForm.title',
    message: 'contactForm.message',
    email: 'contactForm.email',
    buttonText: 'contactForm.buttonText'
  }

  return (
    <Form onSubmit={handleSubmit(onSubmitInfo)} >
      <Field id="email" name="email" label={t(keys.email, { framework: 'React' })} placeholder="a@a.com" component={RenderField} type="email" autoComplete="email" />
      <Field id="message" name="message" label={t(keys.message, { framework: 'React' })} component={TextAreaField} type="text" />
      <Button primary fluid type="submit">{t(keys.buttonText, { framework: 'React' })}</Button>
    </Form>
  );
};

ContactForm.propTypes = {
  onSubmitInfo: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
});

const ContactFormConnected = connect(mapStateToProps)(ContactForm);

const ContactFormNoTranslation = reduxForm({
  form: 'contactUs', // a unique name for this form
  destroyOnUnmount: false,
  validate,
})(ContactFormConnected);


const CForm = withTranslation('common')(ContactFormNoTranslation)

export default CForm;


// WEBPACK FOOTER //
// ./src/features/common/ContactForm.js